module.exports = __webpack_public_path__ + "static/media/green_nebula_skybox_FT.3905da07.png";